var app = angular.module("leonardo");

var VendorListActions = function($scope, $state, ngDialog, AuthDataService, PermissionService) {

  $scope.permissionService = PermissionService;

  $scope.authDataService = AuthDataService;

  $scope.showVendorCategoryAddDialog = function() {
    ngDialog.open({
      template: 'views/templates/dialog/vendor/category-add.html',
      controller: 'VendorCategoryAddDialog',
      data: {
        mode: 'create'
      }
    });
  };

  $scope.goToAddVendor = function() {
    $state.go('vendors.add');
  }
};

app.controller('VendorListActions', ['$scope', '$state', 'ngDialog', 'AuthDataService', 'PermissionService', VendorListActions]);
